import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { isLoggedInUser } from '../../../contexts/User/helpers/userContextHelpers';
import { hasCoupons } from '@wix/ambassador-challenges-v1-challenge/http';
import { request } from '../../../services/request';
import { handleError } from '../../../contexts/ErrorHandler/errorHandlerPropsMap';

export const coupons = async (flowAPI: ControllerFlowAPI) => {
  if (!isLoggedInUser(flowAPI)) {
    return { hasCouponsForPrograms: false };
  }
  try {
    const resp = await request({
      flowAPI,
      options: hasCoupons({}),
      ignoreError: true, // coupons are not essential for the payment flow
      errorOptions: {
        errorCodesMap: {
          applicationError: {},
        },
      },
    });
    return {
      hasCouponsForPrograms: resp.data.result,
    };
  } catch (e) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(e);
    handleError({ resolvedError, error: e, context: 'coupons' });
    return { hasCouponsForPrograms: false };
  }
};
